import { Pipe, PipeTransform } from '@angular/core';

import { BetaFeatures } from '@vi-iot/client';
@Pipe({
  name: 'beta',
  standalone: true,
})
export class BetaPipe implements PipeTransform {
  beta = 'beta';
  transform(feature: string): string {
    if (!feature) return '';

    return BetaFeatures.includes(feature) ? this.beta : '';
  }
}
